import { useCompetitions } from '@/api/hooks/useCompetitions'
import { AdminOnlyRoute } from '@/components/admin-only-route'
import { StateSwitcher } from '@/components/atoms/state-switcher'
import PageLayout from '@/components/layout/page-layout'
import CompetitionsTable from '@/components/organisms/competitions-table/competitions-table'
import { Button } from '@/components/ui/button'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { PlusIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/_authenticated/competitions/')({
  component: () => (
    <AdminOnlyRoute>
      <CompetitionsPage />
    </AdminOnlyRoute>
  ),
})

function CompetitionsPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { data: competitions = [], isError, isLoading } = useCompetitions()

  return (
    <PageLayout title={t('navigation.competitions')}>
      <div className="flex flex-col gap-4">
        <div className="flex justify-end">
          <Button onClick={() => navigate({ to: '/competitions/new' })}>
            <PlusIcon />
            {t('competitionsPage.createButton')}
          </Button>
        </div>
        <StateSwitcher isError={isError} isLoading={isLoading}>
          <CompetitionsTable
            competitions={competitions}
            onClickCompetition={competition =>
              navigate({
                to: '/competitions/$competitionId',
                params: { competitionId: competition.id },
              })
            }
          />
        </StateSwitcher>
      </div>
    </PageLayout>
  )
}
